import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteFichaRoutingModule } from './central-cliente-ficha-routing.module';
import { CentralClienteFichaComponent } from './central-cliente-ficha.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';



@NgModule({
  declarations: [
    CentralClienteFichaComponent
  ],
  imports: [
    CommonModule,
    CentralClienteFichaRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    MessagesModule,
    InputMaskModule,
    DividerModule,
    CardModule,
    AccordionModule,
    BadgeModule,
    TooltipModule,
    DialogModule,
    InputSwitchModule,
    DropdownModule,
    InputTextareaModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    CheckboxModule,
    RadioButtonModule,
    BlockUIModule,
    PanelModule,
    InputNumberModule,
    CalendarModule
    
  ],
  providers: [ConfirmationService]
})
export class CentralClienteFichaModule { }
